import {Record} from 'immutable';
import AuthService, {TOKEN_ALIAS} from 'services/auth';

interface UserInfoType {
    catalog_id: string;
    name: string;
    email: string;
    roles: string[];
    fixed: string;
    mobile: string;
    number: string;
    picture: string;
    max_session_idle_seconds: number;
    customer_id: number;
    customer_name: string;
    department_name: string;
}

interface UserRecordType {
    id: string;
    name: string;
    email: string;
    roles: string[];
    fixed: string;
    mobile: string;
    number: string;
    picture: string;
    maxIdle: number;
    customerId: number;
    customerName: string;
    catalogID: string;
    departmentName: string;
}

const UserRecord = Record<UserRecordType>({
	id: '',
	name: '',
	email: '',
	roles: [],
	fixed: '',
	mobile: '',
	number: '',
	picture: '',
	maxIdle: 0,
	customerId: 0,
	customerName: '',
	catalogID: '',
	departmentName: '',
});

export default class UserModel extends UserRecord {
	/**
	 * @constructor
	 * @param {UserInfoType} props
	 */
	constructor(props: UserInfoType) {
		super({
			id: props.catalog_id,
			name: props.name,
			email: props.email,
			roles: props.roles,
			fixed: props.fixed,
			mobile: props.mobile,
			number: props.number,
			picture: props.picture,
			maxIdle: props.max_session_idle_seconds,
			customerId: props.customer_id,
			customerName: props.customer_name,
			catalogID: props.catalog_id,
			departmentName: props.department_name,
		});
	}

	/**
	 * @type {string}
	 */
	get avatarSrc() {
		return `${AuthService.apiUrl}catalog/profileimage?u=${this.id}&s=128x128&c=${this.customerId}&h=${this.picture}`;
	}

	/**
	 * @param {string} catalogId
	 * @param {number} customerId
	 * @param {string} picture
	 * @return {string}
	 */
	static getAvatarUrl(catalogId: string, customerId: number, picture: string) {
		if (!catalogId || !customerId || !picture) return '';
		return `${AuthService.apiUrl}catalog/profileimage?u=${catalogId}&s=128x128&c=${customerId}&h=${picture}`;
	}

	/**
	 * @return {{cuid: [number]}}
	 */
	get impersonedData() {
		const token = localStorage.getItem(TOKEN_ALIAS);
		if (!token) return null;
		return AuthService.parseToken(token)?.imp;
	}
}
